import PageTableHeader from "../../../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../../../components/table/table";
import { useCommonFetch } from "../../../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import {
  createCategory,
  deleteCategory,
  getStockItemsDetail,
  updateCategory,
} from "../../../../../../services/workspace/inventory.service";
import { useNavigate, useParams } from "react-router-dom";

const actions_type = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  DELETE: "DELETE",
  ASSIGN: "ASSIGN",
  CLEAR: "CLEAR",
  EXPIRE: "EXPIRE",
};

const ItemsCard = ({filters}) => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  
  const customCase = {
    0: { label: "Assigned", color: "text-green-600 text-sm", bg: "bg-green-500" },
    1: { label: "Not Assigned", color: "text-yellow-600 text-sm", bg: "bg-yellow-600" },
    2: { label: "Damaged", color: "text-orange-600 text-sm", bg: "bg-orange-600" },
    3: { label: "Expired", color: "text-red-500 text-sm", bg: "bg-green-600" },
  };

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    handlePageChange,
    openModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
  } = useCommonFetch(getStockItemsDetail, {
    id: id,
    dataPath: "stock.data",
    totalPath: "stock.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
    },

    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item?.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "name",
          },
          assign_to: {
            data: item?.assignedTo?.user?.name || "-",
            className: "",
            sticky: false,
            variant: "text",
          },
          assign_date: {
            data: item?.assignedTo?.created_at,
            className: "",
            sticky: false,
            variant: "date-time",
          },

          status: {
            data: item?.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: customCase,
          },
        }));

        const actionButton = {
          
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  useEffect(()=>{
    if(filters.name){
 fetchData({status:filters.name?filters.name:''},true,id)
    }else{
 fetchData({},true,id)
    }
    
  },[filters])

  const TableHeaderData = [
    {
      label: "Code",
      key: "code",
    },
    {
      label: "Assign To",
      key: "assign_to",
    },
    {
      label: "Assign Date",
      key: "assign_date",
    },
    {
      label: "Status",
      key: "status",
    },
  ];


  return (
    <div className={"flex flex-col gap-2"}>
      <CommonTable
        search={search}
        TableHeaderData={TableHeaderData}
        tabledata={tableData.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={loading}
        action={tableData.action}
      />
    </div>
  );
};
export default ItemsCard;
